var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8480_756197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3136 10.4375L19.8261 13.925C19.4261 14.325 19.7011 15 20.2636 15H22.5011C22.5011 19.1375 19.1386 22.5 15.0011 22.5C14.0136 22.5 13.0511 22.3125 12.1886 21.95C11.7386 21.7625 11.2261 21.9 10.8886 22.2375C10.2511 22.875 10.4761 23.95 11.3136 24.2875C12.4511 24.75 13.7011 25 15.0011 25C20.5261 25 25.0011 20.525 25.0011 15H27.2386C27.8011 15 28.0761 14.325 27.6761 13.9375L24.1886 10.45C23.9511 10.2 23.5511 10.2 23.3136 10.4375ZM7.50114 15C7.50114 10.8625 10.8636 7.5 15.0011 7.5C15.9886 7.5 16.9511 7.6875 17.8136 8.05C18.2636 8.2375 18.7761 8.1 19.1136 7.7625C19.7511 7.125 19.5261 6.05 18.6886 5.7125C17.5511 5.25 16.3011 5 15.0011 5C9.47614 5 5.00114 9.475 5.00114 15H2.76364C2.20114 15 1.92614 15.675 2.32614 16.0625L5.81364 19.55C6.06364 19.8 6.45114 19.8 6.70114 19.55L10.1886 16.0625C10.5761 15.675 10.3011 15 9.73864 15H7.50114Z",
    fill: "#F59E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8480_756197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/Replace.39e86f96590419fa7fb50893f1b658ca.svg";
export { ForwardRef as ReactComponent };